var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11V7.25C3 6.25544 3.39509 5.30161 4.09835 4.59835C4.80161 3.89509 5.75544 3.5 6.75 3.5H10.5M3 26V29.75C3 30.7446 3.39509 31.6984 4.09835 32.4016C4.80161 33.1049 5.75544 33.5 6.75 33.5H10.5M25.5 3.5H29.25C30.2446 3.5 31.1984 3.89509 31.9016 4.59835C32.6049 5.30161 33 6.25544 33 7.25V11M25.5 33.5H29.25C30.2446 33.5 31.1984 33.1049 31.9016 32.4016C32.6049 31.6984 33 30.7446 33 29.75V26M14.25 16.625V12.875C14.25 11.8804 14.6451 10.9266 15.3484 10.2233C16.0516 9.52009 17.0054 9.125 18 9.125C18.9946 9.125 19.9484 9.52009 20.6516 10.2233C21.3549 10.9266 21.75 11.8804 21.75 12.875V16.625M10.5 18.5C10.5 18.0027 10.6975 17.5258 11.0492 17.1742C11.4008 16.8225 11.8777 16.625 12.375 16.625H23.625C24.1223 16.625 24.5992 16.8225 24.9508 17.1742C25.3025 17.5258 25.5 18.0027 25.5 18.5V24.125C25.5 24.6223 25.3025 25.0992 24.9508 25.4508C24.5992 25.8025 24.1223 26 23.625 26H12.375C11.8777 26 11.4008 25.8025 11.0492 25.4508C10.6975 25.0992 10.5 24.6223 10.5 24.125V18.5Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessIcon);
export default __webpack_public_path__ + "static/media/AccessIcon.f1940125c1f1db9bb644423ebed613ff.svg";
export { ForwardRef as ReactComponent };